// reactstrap components
import {
  Badge,
  Card,
  Input,
  CardHeader,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Container,
  Row,
} from "reactstrap";

import { useState, useEffect, useRef } from "react";
// core components
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import ModalImage from "react-modal-image";

//data
import {
  DEPOSIT_API,
  USERS_API,
  REJECT_DEPOSIT_API,
  CONFIRM_DEPOSIT_API,
  PAYMENT_PROVIDER_API,
} from "../../../services/CONSTANTS";
import {
  getApiDataService,
  postApiDataService,
} from "../../../services/apiServices";
import DateRangePicker from "react-bootstrap-daterangepicker";
import ImgModal from "./ImgModal";
import {
  ConfirmDialog,
  DataTable,
  FilterBar,
  StatusBadge,
  TablePagination,
} from "components/shared";
import EditModal from "./EditModal";
import { io } from "socket.io-client";
import { notiCountHandler } from "store/slices/depositNotiSlice";
import { useDispatch } from "react-redux";
import NotificationSound from "../../../assets/sound/notification.mp3";
import useDebounce from "../Util/Debounce";
import { MdRemoveRedEye } from "react-icons/md";

const DEPOSIT_COLUMNS = [
  { key: "index", label: "#" },
  { key: "date", label: "Date" },
  { key: "user", label: "User" },
  { key: "provider", label: "Payment Provider" },
  { key: "amount", label: "Amount" },
  { key: "transactionNo", label: "TransactionNo" },
  { key: "paymentSs", label: "PaymentSS" },
  { key: "status", label: "Status" },
  { key: "actions", label: "" },
];

const DepositList = () => {
  const history = useHistory();
  const [deposits, setDeposits] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [item, setItem] = useState(null);

  const [status, setStatus] = useState("");
  let start = moment().startOf("day").toISOString();
  let end = moment().endOf("day").toISOString();
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);

  const [dateChangeEvent, setDateChangeEvent] = useState(true);

  const [gameID, setGameID] = useState("");
  const [csUserId, setCsUserId] = useState("");
  const [orderSearchId, setOrderSearchId] = useState("");
  const [search, setSearch] = useState(null);
  const debounceSearch = useDebounce(search, 1000);


  const [gameList, setGameList] = useState([]);
  const [csList, setCSList] = useState([]);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [meta, setMeta] = useState({});
  const [imgModal, setImgModal] = useState(false);
  const [img, setImg] = useState(null);

  const [isShowEditModal, setIsShowEditModal] = useState(false);
  const [isShowDeleteModal, setIsShowDeleteModal] = useState(false);
  const [amount, setAmount] = useState(null);

  const [apiUrl, setApiUrl] = useState(null);

  const dispatch = useDispatch();
  const audioPlayer = useRef(null);

  useEffect(() => {
    let api =
      DEPOSIT_API +
      `?sorting=asc&page=${page}&perPage=${perPage}&source=dashboard`;
    api += status ? `&status=${status}` : "";
    api += gameID ? `&payment_provider_id=${gameID}` : "";
    api += orderSearchId ? `&order_id=${orderSearchId}` : "";

    api += csUserId ? `&cs_user_id=${csUserId}` : "";
    api += debounceSearch ? `&search=${debounceSearch}` : "";

    if (startDate && endDate) {
      api += `&start_date=${startDate}&end_date=${endDate}`;
    }
    fetchDepositData(api);
    setApiUrl(api);
  }, [
    dateChangeEvent,
    page,
    perPage,
    status,
    gameID,
    orderSearchId,
    csUserId,
    debounceSearch,
  ]);

  // useEffect(() => {
  //   depositSockerHandler();
  // }, []);

  const depositSockerHandler = () => {
    const socket = io(process.env.REACT_APP_SOCKET_URL, {
      transports: ["websocket"],
    });
    socket.on("deposit-store", (data) => {
      console.log("deposit-store socket", data);
      let noti_count = 1;
      dispatch(notiCountHandler(noti_count));
      dispatch(notiCountHandler(0));
      // toast.info(`You have ${noti_count} new deposit!`);
      audioPlayer.current.play();
      //add to lastet index
      if (deposits.length <= perPage) {
        setDeposits((prev) => [...prev, data]);
      }
    });
  };

  let fetchDepositData = (url) => {
    setIsShowEditModal(false);
    setIsLoading(true);
    getApiDataService(url)
      .then((res) => {
        setDeposits(res.data);
        setIsLoading(false);
        setMeta(res.meta);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setIsLoading(false);
        setDeposits([]);
        setMeta({});
      });
    return () => {
      console.log("axios cleanup.");
    };
  };
  function fetchCSData() {
    getApiDataService(USERS_API + "?role=CS")
      .then((res) => {
        console.log("res.data", res.data);
        setCSList(res.data);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setCSList([]);
      });
  }

  //handle event process
  let handleRejected = (data) => {
    let id = data.id;
    let remark = data.remark;
    // status = confirmed,pending,rejected
    setIsLoading(true);
    postApiDataService(REJECT_DEPOSIT_API(id), {
      remark: remark,
    })
      .then((res) => {
        console.log("res.data=", res.data);
        setIsLoading(false);
        setIsShowDeleteModal(false);
        // toast.success(`Deposit Rejected successfully!`);
        fetchDepositData(apiUrl);
      })
      .catch((err) => {
        // toast.error(`System Error ! Please contact developer!`);
        console.log("Error in handleConfirm!", err);
      });
  };

  let handleCompleted = (id, topup_amount) => {
    console.log("id:", id);
    // status = confirmed,pending,rejected
    setIsLoading(true);
    postApiDataService(CONFIRM_DEPOSIT_API(id), {
      topup_amount: topup_amount,
    })
      .then((res) => {
        console.log("res.data=", res.data);
        setIsLoading(false);
        // toast.success(`Deposit Confirm successfully!`);
        fetchDepositData(apiUrl);
      })
      .catch((err) => {
        // toast.error(`System Error ! Please contact developer!`);
        console.log("Error in handleConfirm!", err);
        setIsLoading(false);
      });
  };

  let handleDelete = (item) => {
    setItem(item);
    setIsShowDeleteModal(true);
  };

  let handelEditOnSubmit = (data) => {
    let id = data.id;
    let topup_amount = data.topup_amount;
    console.log("handelEditOnSubmit", data);
    handleCompleted(id, topup_amount);
  };

  let handleEdit = (item) => {
    setItem(item);
    setIsShowEditModal(true);
  };

  useEffect(() => {
    fetchGameData();
    fetchCSData();
    let user_id = sessionStorage.getItem("user_id");
    let user_role = sessionStorage.getItem("user_role");
    if (user_role === "CS") {
      setCsUserId(user_id);
    }
  }, []);

  //util
  function fetchGameData() {
    getApiDataService(PAYMENT_PROVIDER_API)
      .then((res) => {
        setGameList(res.data);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setGameList([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  }
  // Toggle for Modal

  const is_filtering = () => {
    let boo = false;
    if (
      status ||
      gameID ||
      orderSearchId ||
      startDate ||
      endDate ||
      csUserId ||
      search
    ) {
      boo = true;
    }
    return boo;
  };

  const handleReset = () => {
    console.log("reset");
    setGameID("");
    setOrderSearchId("");
    setStatus("");
    setStartDate("");
    setEndDate("");
    setSearch("");
  };

  const handleCallback = (start, end, label) => {
    console.log(start.toISOString(), "startDate1");
    console.log(end.toISOString(), "EndDate2");
    // moment('2020-06-05').format('YYYY-MM-DDTHH:mm:ssZ')
    setStartDate(start.toISOString());
    setEndDate(end.toISOString());

    setDateChangeEvent(!dateChangeEvent);
    console.log("dateChangeEvent", dateChangeEvent);
  };

  const handleGameID = (event) => {
    setGameID(event.target.value);
    console.log("gameID:", gameID);
  };
  const handleStatus = (event) => {
    setStatus(event.target.value);
    console.log("status:", status);
  };

  const handleCSID = (event) => {
    setCsUserId(event.target.value);
    console.log("csUserId:", csUserId);
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
    console.log("search", event.target.value);
  };

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7 akh-page-content" fluid>
        <audio ref={audioPlayer} src={NotificationSound} />
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                {/* <button className="btn btn-primary" onClick={showNotiCount} >Show Noti</button> */}
                <FilterBar
                  title="Deposit"
                  onClear={handleReset}
                  isFiltering={is_filtering()}
                >
                  <DateRangePicker onCallback={handleCallback}>
                    <input
                      className="form-control akh-filter-width"
                      placeholder="Select date range"
                      aria-label="Date range"
                    />
                  </DateRangePicker>
                  <Input
                    className="akh-filter-select"
                    type="select"
                    value={status}
                    onChange={handleStatus}
                    aria-label="Filter by status"
                  >
                    <option value=""> All Status </option>
                    <option value="pending"> Pending </option>
                    <option value="completed"> Completed </option>
                    <option value="rejected"> Rejected </option>
                  </Input>
                  <Input
                    className="akh-filter-select"
                    type="select"
                    onChange={handleGameID}
                    value={gameID}
                    aria-label="Filter by payment provider"
                  >
                    <option value=""> All Payment </option>
                    {gameList.map((game, index) => {
                      return (
                        <option key={index} value={game.id}>
                          {game.name}
                        </option>
                      );
                    })}
                  </Input>
                  {sessionStorage.getItem("user_role") === "ADMIN" && (
                    <Input
                      className="akh-filter-select"
                      type="select"
                      onChange={handleCSID}
                      value={csUserId}
                      aria-label="Filter by CS user"
                    >
                      <option value=""> All CS </option>
                      {csList.map((cs, index) => {
                        return (
                          <option key={index} value={cs.id}>
                            {cs.name}
                          </option>
                        );
                      })}
                    </Input>
                  )}
                  <Input
                    name="search"
                    className="akh-filter-width"
                    placeholder="Search"
                    aria-label="Search deposits"
                    type="text"
                    value={search ?? ""}
                    onChange={handleSearch}
                  />
                </FilterBar>
              </CardHeader>
              <DataTable
                className="table-striped"
                columns={DEPOSIT_COLUMNS}
                data={deposits}
                isLoading={isLoading}
                emptyMessage="No records found"
                renderRow={(deposit, index) => (
                  <tr key={deposit?.id ?? index}>
                    <th>{(meta.page - 1) * meta.perPage + index + 1}</th>
                    <td
                      title={moment(
                        new Date(Date.parse(deposit?.createdAt))
                      ).fromNow()}
                    >
                      {moment(deposit?.createdAt).format("DD/MM h:mm:ss a")}
                      <br></br>
                      <Badge color="primary" pill>
                        {moment(
                          new Date(Date.parse(deposit?.createdAt))
                        ).fromNow()}
                      </Badge>
                    </td>
                    <td>
                      {deposit?.user?.name}
                      <br />
                      <span className="ml-1">
                        <Badge color="primary" pill className="font-mono">
                          {deposit?.user?.userCode}
                        </Badge>
                      </span>
                    </td>
                    <th scope="row">
                      {deposit?.payment_account ? (
                        <Media className="align-items-center">
                          <a
                            className="avatar rounded-circle mr-3"
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          >
                            <img
                              alt="..."
                              src={
                                deposit?.payment_account?.payment_provider
                                  ?.logo
                              }
                              style={{ width: "40px" }}
                            />
                          </a>
                          <span className="mb-0 text-sm">
                            {deposit?.payment_account?.account_name}
                          </span>
                          <span className="mb-0 text-sm">
                            ( {deposit?.payment_account?.account_no} )
                          </span>
                        </Media>
                      ) : (
                        "Direct Topup"
                      )}
                    </th>
                    <td>
                      <span className="mb-0 text-lg">
                        <Badge color="primary" pill className="font-mono">
                          {deposit?.deposit_amount} {deposit?.currency}
                        </Badge>
                      </span>
                    </td>
                    <td className="font-mono">{deposit?.transaction_no}</td>

                    <td style={{ textAlign: "center" }}>
                      {deposit?.payment_ss ? (
                        <button
                          onClick={() => {
                            setImgModal(true);
                            setImg(deposit?.payment_ss);
                          }}
                          style={{
                            border: "none",
                            outline: "none",
                            textAlign: "center",
                            backgroundColor: "transparent",
                          }}
                          aria-label="View payment screenshot"
                        >
                          <MdRemoveRedEye
                            size={25}
                            className="text-primary"
                            aria-hidden="true"
                          />
                        </button>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td title={deposit?.rejected_remark}>
                      <StatusBadge status={deposit?.status} />
                    </td>
                    <td className="text-right">
                      <UncontrolledDropdown>
                        <DropdownToggle
                          className="btn-icon-only text-light"
                          href="#pablo"
                          role="button"
                          size="sm"
                          color=""
                          aria-label="Actions"
                          onClick={(e) => e.preventDefault()}
                        >
                          <i
                            className="fas fa-ellipsis-v"
                            aria-hidden="true"
                          />
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-arrow" right>
                          {deposit?.status != "completed" ? (
                            <>
                              <DropdownItem
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleCompleted(
                                    deposit.id,
                                    deposit.deposit_amount
                                  );
                                }}
                              >
                                Complete (Payment OK)
                              </DropdownItem>

                              <DropdownItem
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEdit(deposit);
                                }}
                              >
                                Edit
                              </DropdownItem>

                              <DropdownItem
                                href="#pablo"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleDelete(deposit);
                                }}
                              >
                                Rejected
                              </DropdownItem>
                            </>
                          ) : null}
                          <DropdownItem
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          >
                            Detail
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                )}
              />
              <TablePagination
                meta={meta}
                page={page}
                setPage={setPage}
                perPage={perPage}
                setPerPage={setPerPage}
              />
            </Card>
          </div>
        </Row>
      </Container>

      {isShowDeleteModal && (
        <ConfirmDialog
          isOpen
          toggle={() => {
            setIsShowDeleteModal(false);
          }}
          title="Are you sure?"
          confirmText="Confirm"
          confirmColor="danger"
          isLoading={isLoading}
          requireRemark={{ label: "Enter Remark" }}
          onConfirm={(remark) =>
            handleRejected({
              id: item?.id,
              status: "rejected",
              remark: remark,
            })
          }
        />
      )}
      {/* <DeleteConfirmInputModal
        modal={modal}
        toggle={toggle}
        id={id}
        handleDelete={handleRejected} */}
      {/* /> */}
      {isShowEditModal && (
        <EditModal
          item={item}
          onSubmit={handelEditOnSubmit}
          onClose={() => {
            setIsShowEditModal(false);
          }}
        ></EditModal>
      )}
      <ImgModal
        imgModal={imgModal}
        onClose={() => setImgModal(false)}
        img={img}
      ></ImgModal>
    </>
  );
};

export default DepositList;
